import styled from 'styled-components'
import { theme } from '@notino/react-styleguide'
import { truncate } from '../../styles/helpers'
import { SALON_DETAIL } from '../../styles/constants'

/**
 * When changing the styles here, especially the ones that affects the size of the component, update SalonDetailPlaceholder as well.
 * We need to keep the same size for both components to prevent Layout Shift.
 * @see src/components/SalonDetailPlaceholder/SalonDetailPlaceholderStyles.tsx
 */

export const SalonDetailItem = styled.a`
	color: inherit;
	text-decoration: none;
	position: relative; // relative for absolute rating
	cursor: pointer;
	min-width: 0; // white-space: no-wrap on categories breaks grid layout, this fixes it

	&:hover h3 {
		text-decoration: underline;
	}
`

export const TextContentWrapper = styled.div`
	min-height: ${SALON_DETAIL.TEXT_CONTENT_HEIGHT}px;
`

export const TextContentHeader = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 2px;
	gap: 4px;
`

export const RatingWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`

export const Rating = styled.span`
	color: ${theme.color.text.primary};
	${theme.typography.labelSmall};
`

export const RatingCounts = styled.span`
	color: ${theme.color.text.tertiary};
	${theme.typography.labelSmall400};
`

export const DistanceWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 2px;
	color: ${theme.color.text.tertiary};
	${theme.typography.labelSmall400};

	svg {
		flex-shrink: 0;
		width: 0.875rem;
		height: 0.875rem;
	}
`

export const Title = styled.h3`
	font-size: 1rem;
	line-height: 1.5rem;
	font-weight: 500;
	margin-top: 0; // resetting global notino margin on heading
	margin-bottom: 4px;
	${truncate};
`

export const ImageWrapper = styled.div`
	position: relative;
	aspect-ratio: ${SALON_DETAIL.IMAGE_ASPECT_RATIO};
	margin-bottom: ${SALON_DETAIL.GAP}px;

	& img {
		display: block;
		height: 100%;
		object-fit: cover;
	}
`

export const AvailableRSBadge = styled.div`
	position: absolute;
	background-color: ${theme.color.background.primary};
	border-radius: 2px;
	display: inline-flex;
	gap: 4px;
	padding: 6px 8px;
	${theme.typography.labelSmall};
	color: ${theme.color.text.primary};
	left: 12px;
	bottom: 12px;
	align-items: center;

	svg {
		width: 16px;
		height: 16px;
		flex-shrink: 0;
	}
`

export const Description = styled.p`
	margin-bottom: 0;
	display: flex;
	flex-direction: column;
	gap: 4px;
`

export const Address = styled.span`
	${truncate};
	${theme.typography.labelSmall400};
	display: block;
`

export const OpeningHours = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;

	svg {
		flex-shrink: 0;
	}
`

export const OpeningHoursMessage = styled.span`
	${theme.typography.labelSmall400};
	color: ${theme.color.text.secondary};
	${truncate};

	b {
		color: ${theme.color.text.primary};
		font-weight: 500;
	}
`
